import { IApplicationState } from '../../types/redux';

export const selectIsAuthorized = (state: IApplicationState): boolean => state.calculator.user.isAuthorized;
